// Note: The first file of a module here, must also register the module

import "./collection-purpose-dialog.component";
import "./data-protection-officer-dialog.component";
import "./legal-reason-create-dialog.component";
